<adapt-dialog [maxWidth]="600"
              [expandable]="false"
              [showHelpButton]="false">
    <h3 adapt-dialog-title>Conflicting changes detected</h3>
    <div adapt-dialog-content
         class="content">
        <p>
            <adapt-link-person [person]="changedByPerson"></adapt-link-person>
            has made changes that conflict with yours:
        </p>
        <ul>
            @for (message of conflictingEntityMessages; track message) {
                <li [innerHTML]="message"></li>
            }
        </ul>
        <p class="mb-0">
            @switch (allowKeepLocalChanges) {
                @case (true) {
                    We're going to merge their changes with yours. If there's any conflict, we can either use their version or your version.
                }
                @default {
                    These changes require you to apply their changes.
                }
            }
        </p>
    </div>

    <div class="buttons"
         adapt-dialog-footer
         adaptBlockingButtonGroup>
        @switch (allowKeepLocalChanges) {
            @case (true) {
                <button adaptButton="default"
                        (click)="useTheirChanges()">Use their changes</button>
            }
            @case (true) {
                <button adaptButton="default"
                        (click)="useMyChanges()">Use my changes</button>
            }
            @default {
                <button adaptButton="default"
                        (click)="useTheirChanges()">Apply their changes</button>
            }
        }
    </div>
</adapt-dialog>
